/**
 * ChatBot Consent Banner
 *
 * Handles the interaction with the chatbot consent banner
 * This file is a bridge between the DOM elements and the ConsentService
 */

/* eslint-disable no-undef */
import sofabuddyConsentService from '@lib/sofabuddyConsentService';

const consentButtons = document.querySelectorAll(
  '.js-sofabuddy-consent-button'
);
const $successConsentPopup = $('#sofabuddy-success-consent-popup');
const redirectPathConsentGiven = $successConsentPopup.data('redirect-path');
const amplitudeEventConsent = $successConsentPopup.data('amplitude-event');
const eventPropertiesConsent = $successConsentPopup.data('event-properties');
const microphoneConsentButtons = document.querySelectorAll(
  '.js-microphone-consent-button'
);
const microphoneConsentCheckboxes = document.querySelectorAll(
  '.js-microphone-consent-checkbox'
);

const makeMicrophoneConsentRequest = async button => {
  const userId = window.Sofatutor?.user?.id;
  const value = button.dataset.value;
  // Always enable microphone feature
  await sofabuddyConsentService.updateMicrophoneConsent(userId, value);
  window.location.reload();
};

const makeConsentRequest = async (showPopup = false) => {
  try {
    const userId = window.Sofatutor?.user?.id;
    // Always set chatbot consent
    await sofabuddyConsentService.updateChatbotConsent(userId, 'true');
    // Only set microphone consent if checkbox exists and is checked
    const micConsentCheckbox = document.querySelector(
      'input[name="microphone_consent"]'
    );
    if (micConsentCheckbox) {
      await sofabuddyConsentService.updateMicrophoneConsent(
        userId,
        micConsentCheckbox.checked
      );
    }
    sofabuddyConsentService.track(
      amplitudeEventConsent,
      eventPropertiesConsent
    );
    if (showPopup) {
      openConsentPopup();
    }
  } catch (error) {
    console.error('Error updating consent:', error);
  }
};

microphoneConsentButtons.forEach(button => {
  button.addEventListener('click', function() {
    makeMicrophoneConsentRequest(button);
  });
});

consentButtons.forEach(button => {
  button.addEventListener('click', function() {
    makeConsentRequest(button.dataset.chatbotConsent, true);
  });
});

const openConsentPopup = () => {
  new Foundation.Reveal($successConsentPopup);
  $successConsentPopup.foundation('open');
  startProgressBar();
};

microphoneConsentCheckboxes.forEach(checkbox => {
  checkbox.addEventListener('change', function() {
    microphoneConsentCheckboxes.forEach(cb => {
      cb.checked = this.checked;
    });
  });
});

const startProgressBar = () => {
  const progressbar = document.querySelector(
    '.js-progress-bar .progress-meter'
  );
  let progress = Sofatutor.env == 'test' ? 90 : 0;

  const updateProgress = setInterval(() => {
    progress += 1;
    progressbar.style.width = `${progress}%`;

    if (progress >= 100) {
      clearInterval(updateProgress);
      window.location.href = redirectPathConsentGiven;
    }
  }, 50);
};

// Initialize the consent service when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  // Get configuration data from DOM elements
  const $successConsentPopup = $('#sofabuddy-success-consent-popup');

  // Only initialize if the popup element exists
  if ($successConsentPopup.length > 0) {
    const redirectPath = $successConsentPopup.data('redirect-path');
    const amplitudeEvent = $successConsentPopup.data('amplitude-event');
    const eventProperties = $successConsentPopup.data('event-properties');

    // Initialize consent service with options
    sofabuddyConsentService.init({
      amplitudeEventConsent: amplitudeEvent,
      eventPropertiesConsent: eventProperties,
      redirectPathConsentGiven: redirectPath
    });
  }
});
